import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "轉介醫院",
    isNumber: true,
  },
];

export const VillageHealthInsuranceReferralsCompletionRate = {
  label: "18鄉鎮符合健保用藥個案轉介醫療院所完成率",
  key: "VillageHealthInsuranceReferralsCompletionRate",
  path: "BoneMuscleCare/VillageHealthInsuranceReferralsCompletionRate",
  api: "TCS_V_HealthInsuranceReferralsCompletionRate",
  render: (options) => (
    <Diagram.BoneMuscleCare.VillageHealthInsuranceReferralsCompletionRate
      {...options}
    />
  ),
  isGroup: true,
  groupColumns: [
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "",
    },
  ],
  dateRangeColumns: [
    { label: "篩檢日期", key: "篩檢日期" },
    { label: "開案日期", key: "開案日期" },
  ],
  filterColumns: [
    { key: "鄉鎮", type: "string" },
    { key: "篩檢日期", type: "date" },
    { key: "開案日期", type: "date" },
  ],
  levelColumns,
  columns: [],
};
